import './button.css';

const Button = ({ children, variant, ...props }) => (
  <button class={variant} {...props}>{children}</button>
);

export default Button;